import React, { useState } from 'react';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import Badge from '@mui/material/Badge';
import * as R from 'ramda';

import { NoAvailableCard } from 'common';
import { INITIAL_FILTERS_STATE } from './constants';
import CardPanel from './TerminalDetailsAlertsCardPanel';
import Filters from './TerminalDetailsAlertsFilters';
import MobileFilters from './MobileFilters';

const TerminalDetailsAlerts = ({
  alertCount,
  filtersState,
  isActiveEmail,
  isActiveSMS,
  setFiltersState,
  terminalAlertsQuery,
}) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('md'), { noSsr: true });

  const [isFiltersDrawerOpen, setIsFiltersDrawerOpen] = useState(false);

  const resetFilters = () => setFiltersState(R.mergeLeft(INITIAL_FILTERS_STATE));

  return (
    <Box>
      <Box
        alignItems="center"
        display="flex"
        justifyContent="space-between"
        mb={1.5}
        pl={{ md: 0, xs: 2 }}
        pr={{ md: 0, xs: 1 }}
      >
        <Typography variant="h5">
          <Badge
            invisible={!alertCount}
            sx={{
              '.MuiBadge-badge': {
                backgroundColor: 'error.dark',
                right: -10,
                top: '10%',
              },
            }}
            variant="dot"
          >
            Alerts
          </Badge>
        </Typography>
        {isMobile && (
          <MobileFilters
            filtersState={filtersState}
            isOpen={isFiltersDrawerOpen}
            setFiltersState={setFiltersState}
            setIsOpen={setIsFiltersDrawerOpen}
          />
        )}
      </Box>
      <Divider sx={{ mx: { md: 0, xs: 2 } }} />
      <Filters
        filtersState={filtersState}
        isActiveEmail={isActiveEmail}
        isActiveSMS={isActiveSMS}
        resetFilters={resetFilters}
        setFiltersState={setFiltersState}
      />
      {terminalAlertsQuery.length ? (
        <CardPanel terminalAlertsQuery={terminalAlertsQuery} />
      ) : (
        <NoAvailableCard type="Alerts" />
      )}
    </Box>
  );
};

TerminalDetailsAlerts.propTypes = {
  alertCount: number,
  filtersState: shape({
    outageCategory: arrayOf(string),
    timeRange: shape({ label: string, value: string }),
  }).isRequired,
  isActiveEmail: bool,
  isActiveSMS: bool,
  setFiltersState: func.isRequired,
  terminalAlertsQuery: arrayOf(shape).isRequired,
};

TerminalDetailsAlerts.defaultProps = {
  alertCount: 0,
  isActiveEmail: false,
  isActiveSMS: false,
};

export default TerminalDetailsAlerts;
